// extracted by mini-css-extract-plugin
export default {"AskAicaQuestionBadge":"AskAicaQuestionBadge_AskAicaQuestionBadge__SOM85","shine":"AskAicaQuestionBadge_shine__rXSwz"};